import $ from 'jquery';
import Cookies from 'js-cookie';

$(function () {

    $('[data-section-switch]').on('click', function (e) {
        var section = Cookies.get('bemoSection');
        var newSection = section == 'rail' ? 'shunting' : 'rail';
        var urls = $(this).data('section-switch');
        setSection(newSection);
        window.location.href = urls[newSection];
    });

    // var initCookieScriptModal = function (el) {
    //     var wrapper = el.find('#cookiescript_wrapper');
    //     wrapper.wrap("<div></div>").parent().attr('id', 'cookiescript_flex');
    //     el.find('#cookiescript_close, #cookiescript_intro').remove();
    //     //wrapper.prepend(window.App.cookieScriptIntro);
    // };

    // $('body').on('click', '#cookiescript_badge', function (e) {
    //     setTimeout(function () {
    //         var el = $('#cookiescript_injected');
    //         if (el.length) {
    //             initCookieScriptModal(el);
    //         }
    //     }, 500)
    // });

    // $(window).on('CookieScriptLoaded', function () {
    //     setTimeout(function () {
    //         var el = $('#cookiescript_injected');
    //         if (el.length) {
    //             //initCookieScriptModal(el);
    //             //$('body').addClass('no-scroll');
    //         }

    //     }, 500);
    // });

    // $(window).on('CookieScriptAccept CookieScriptAcceptAll CookieScriptReject CookieScriptClose', function (e) {
    //     $('body').removeClass('no-scroll');
    // });

});

const setSection = function (section) {
    var expires = new Date(new Date().getTime() + 15 * 60 * 1000);
    Cookies.set('bemoSection', section, { expires: expires });
    $('body').removeClass('section-rail section-shunting').addClass('section-' + section);
}

const initSection = function () {

    var CSC = Cookies.get('CookieScriptConsent');
    var notified = Cookies.get('bemoSectionNotified');

    var showNotification = function () {

        if (window.bemoSection) {
            setSection(window.bemoSection);
        }

        var switchEl = $('[data-section-switch]:visible div');
        if (!switchEl.length || notified || !window.bemoSection) return;

        var html = `<div class='section-message'><p>${window.App.sectionMessage[window.bemoSection]}</p></div>`;
        var el = $(html).appendTo($('body'));
        var pos = switchEl.offset();
        var y = pos.top + switchEl.outerHeight() + 10;
        var x = pos.left + 0.5 * (switchEl.outerWidth() - el.outerWidth());
        var min = 20;
        var max = $(window).width() - 20 - el.outerWidth();
        if (x < min) {
            x = pos.left;
            el.addClass('left');
        } else if (x > max) {
            x = post.left + switchEl.outerWidth() - el.outerWidth();
            el.addClass('right');
        }
        el.css({ left: x, top: y });
        el.on('click', function (e) {
            el.remove();
        });
        $(window).one('resize', function (e) {
            el.remove();
        });
        var expires = new Date(new Date().getTime() + 15 * 60 * 1000);
        Cookies.set('bemoSectionNotified', 1, { expires: expires });
    }

    if (window.CookieScript) {
        if (CSC) {
            showNotification();
        }
    } else {
        showNotification();
    }

    $(window).on('CookieScriptAccept CookieScriptAcceptAll CookieScriptReject', function (e) {
        showNotification();
    });

}

export default {
    init: function () {
        initSection();
    }
}
